// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./NixieOne-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Arial, sans-serif';
} */



/* .login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 60vh;
}

.login-box {
  padding: 30px;
  border: 1px solid #ddd;
  border-radius: 5px;    
background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.input-group {
  margin-bottom: 1px;
}

.input-field {
  width: 250px;
  padding: 10px;
  margin: 5px 0;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.action-button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  margin: 0px;
}

.action-button:hover {
  background-color: #0056b3;
} */

@font-face {
  font-family: 'CustomFont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}



.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-family: 'CustomFont';
}

.login-box {
  border-radius: 5px;
  background-color: #FAECE0;
  color: #8E701A;
  width: 100%;
  height: auto;
  max-width: 517px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 40px;
  font-family: "CustomFont";
}

.bottom-box {
  height: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  padding-top: 10px;
  box-sizing: border-box;
  font-family: "CustomFont";
}


.login-line {
  width: 100%;
  height: 1px;
  background-color: #DAC9B1;
  margin: 15px auto;
}



label {
  display: block;
  margin-bottom: 3px;
  font-size: 18px;
}

.login-input-group {
  margin-bottom: 10px;
  width: 100%;
}

.login-input-field {
  width: 100%;
  padding: 12px;
  margin: 5px 0;
  border-radius: 4px;
  border: 0.58px solid #8E701A;
  font-family: 'CustomFont';
  color: #8E701A; 
  box-sizing: border-box;
}

.login-action-button {
  font-family: 'CustomFont';
  font-size: 18px;
  width: 100%;
  height: 40px;
  padding: 10px;
  background-color: #DCC1B5;
  color: #fff;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  margin-top: 5px;
  box-sizing: border-box;
}

.login-action-button:hover {
  background-color: #DCC1B5;
}`, "",{"version":3,"sources":["webpack://./src/components/auth.css"],"names":[],"mappings":"AAAA;;;;;GAKG;;;;AAIH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwCG;;AAEH;EACE,yBAAyB;EACzB,+DAAqD;AACvD;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;;;AAIA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Arial, sans-serif';\n} */\n\n\n\n/* .login-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 60vh;\n}\n\n.login-box {\n  padding: 30px;\n  border: 1px solid #ddd;\n  border-radius: 5px;    \nbackground-color: rgba(255, 255, 255, 0.8);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.input-group {\n  margin-bottom: 1px;\n}\n\n.input-field {\n  width: 250px;\n  padding: 10px;\n  margin: 5px 0;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.action-button {\n  width: 100%;\n  padding: 10px;\n  background-color: #007bff;\n  color: #fff;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  margin: 0px;\n}\n\n.action-button:hover {\n  background-color: #0056b3;\n} */\n\n@font-face {\n  font-family: 'CustomFont';\n  src: url('./NixieOne-Regular.ttf') format('truetype');\n}\n\n\n\n.login-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  font-family: 'CustomFont';\n}\n\n.login-box {\n  border-radius: 5px;\n  background-color: #FAECE0;\n  color: #8E701A;\n  width: 100%;\n  height: auto;\n  max-width: 517px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 40px;\n  font-family: \"CustomFont\";\n}\n\n.bottom-box {\n  height: 40%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  padding-top: 10px;\n  box-sizing: border-box;\n  font-family: \"CustomFont\";\n}\n\n\n.login-line {\n  width: 100%;\n  height: 1px;\n  background-color: #DAC9B1;\n  margin: 15px auto;\n}\n\n\n\nlabel {\n  display: block;\n  margin-bottom: 3px;\n  font-size: 18px;\n}\n\n.login-input-group {\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.login-input-field {\n  width: 100%;\n  padding: 12px;\n  margin: 5px 0;\n  border-radius: 4px;\n  border: 0.58px solid #8E701A;\n  font-family: 'CustomFont';\n  color: #8E701A; \n  box-sizing: border-box;\n}\n\n.login-action-button {\n  font-family: 'CustomFont';\n  font-size: 18px;\n  width: 100%;\n  height: 40px;\n  padding: 10px;\n  background-color: #DCC1B5;\n  color: #fff;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  margin-top: 5px;\n  box-sizing: border-box;\n}\n\n.login-action-button:hover {\n  background-color: #DCC1B5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
